import { render, staticRenderFns } from "./MyOrdersHostingRepresentative.vue?vue&type=template&id=31d5bdc7"
import script from "./MyOrdersHostingRepresentative.vue?vue&type=script&lang=js"
export * from "./MyOrdersHostingRepresentative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports